import type { FC } from 'react';
import React from 'react';
import { TextButton, Headline } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { useUniversalState } from '../context/UniversalStateContext';

interface NoResultsProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const NoResults: FC<NoResultsProps> = ({ onClick }) => {
  const { translations } = useUniversalState();

  return (
    <NoResultsWrapper>
      <StyledHeadline
        variant={{
          order: '1',
          type: 'headline',
          weight: 'normal',
        }}
        tag="h2"
      >
        {translations.noResultHeadline}
      </StyledHeadline>
      <StyledSubheadline
        variant={{
          order: '4',
          type: 'headline',
          weight: 'normal',
        }}
        tag="h3"
      >
        {translations.noResultSubline}
      </StyledSubheadline>
      <TextButton
        variant="primary"
        size="sm"
        onClick={onClick}
        icon="erase"
        aria-label="Reset filter"
      >
        {translations.filterReset}
      </TextButton>
    </NoResultsWrapper>
  );
};

const NoResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledHeadline = styled(Headline)`
  text-align: center;
  padding-bottom: var(--spacing-relative-md);
`;

const StyledSubheadline = styled(Headline)`
  margin-bottom: calc(var(--spacing-relative-lg) + var(--spacing-relative-xs));
`;
